{
  "agent_name": "{{brand}} Manager",
  "crumbs": "You are here",
  "common": {
    "cancel": "Cancel",
    "details": "Details",
    "loading": "Loading",
    "retry": "Retry",
    "saving": "Saving…"
  },
  "nav": {
    "group": "IT monitoring",
    "incidents": "Incidents",
    "unhandled_n": "{{n}} incidents nobody is handling yet",
    "hosts": "Hosts",
    "network": "Network & apps",
    "remote": "Remote assistance"
  },
  "sev": {
    "P1": "Urgent",
    "P2": "Important",
    "P3": "Normal"
  },
  "home": {
    "bad": "Problem",
    "attention": "Attention",
    "ok": "OK",
    "unreadable": "Can't read",
    "unset": "Not set up",
    "maintenance": "Maintenance",
    "maintenance_until": "Maintenance · until {{time}}",
    "off_hours": "Outside business hours",
    "baselining": "Building baseline (does not change status)"
  },
  "now": {
    "ongoing_for": "Ongoing · {{n}} min",
    "recovered_at": "Recovered {{time}}"
  },
  "handling": {
    "open": "Unhandled",
    "open_recovered": "Unhandled (nobody has looked)",
    "acknowledged_by": "Seen by {{name}}",
    "claimed_by": "{{name}} is handling",
    "mine": "You are handling",
    "since": " · since {{time}}",
    "resolved": "Closed"
  },
  "person": {
    "you": "you",
    "someone": "someone",
    "system": "System"
  },
  "impact": {
    "not_recording": "{{n}} cameras not recording · {{min}} min",
    "gap": "Recording gap: {{n}} cameras × {{min}} min (cannot be recovered)",
    "fine": "Recording not affected",
    "fine_note": "Recording not affected: {{note}}",
    "unknown": "Recording status unavailable",
    "unknown_note": "Recording status unavailable: {{note}}"
  },
  "incident": {
    "affected_n": "{{n}} affected",
    "recurring": "Recurring · {{n}} times",
    "for_min": "{{n}} min",
    "silenced_until": "Silenced until {{time}} · {{name}}",
    "alarms_open": "Alarms in same $t(translation:leaf.cur_lc): {{n}}",
    "impact": "Impact",
    "see_gap": "View around the gap",
    "alarm_xref": "{{n}} unhandled alarms in the same $t(translation:leaf.cur_lc)",
    "see_alarms": "View alarms",
    "affected_title": "Affected devices ({{n}})",
    "affected_all": "All {{n}}",
    "col_kind": "Type",
    "col_name": "Name",
    "col_state": "Status",
    "timeline": "Timeline",
    "people": "People on this incident",
    "handler": "Handler",
    "seen_by": "Seen by",
    "resolved_by": "Closed by",
    "escalation": "Escalation",
    "nobody": "Nobody yet",
    "not_found": "This incident can't be found",
    "not_found_body": "It may be past the retention period (13 months), or you no longer have access to this $t(translation:leaf.cur_lc).",
    "not_found_crumb": "Not found",
    "back_list": "Back to incidents",
    "unavailable": "Can't load this incident",
    "abar": "Incident actions",
    "notified": "Notified"
  },
  "target": {
    "camera": "Camera",
    "recorder": "Recorder",
    "host": "Host",
    "network_device": "Network device",
    "probe": "Application probe",
    "kinio_device": "Device"
  },
  "target_state": {
    "not_recording": "Not recording",
    "offline": "Offline",
    "unreadable": "Can't read",
    "recovered": "Recovered",
    "ok": "OK",
    "service_stopped": "Service stopped",
    "on_battery": "On battery"
  },
  "ev": {
    "system": "System",
    "bad": "Problem",
    "person": "Person",
    "recover": "Recovered",
    "notify": "Notification"
  },
  "ev_person": {
    "open": "{{name}}: reopened",
    "acknowledged": "{{name}}: seen",
    "claimed": "{{name}}: I'll handle it",
    "resolved": "{{name}}: closed",
    "assigned": "{{name}}: handed to {{to}}"
  },
  "act": {
    "claim": "I'll handle it",
    "take_over": "Take over",
    "acknowledge": "Seen",
    "resolve": "Mark resolved…",
    "close": "Close…"
  },
  "resolve": {
    "title": "Close this incident",
    "body": "No more escalations or reminders. If the same cause happens again within 30 minutes, it returns to this incident.",
    "note": "What was done (optional)",
    "ok": "Close"
  },
  "conflict": {
    "handled_by": "Already handled by {{name}}; the page has been updated",
    "changed": "Someone just changed this incident; the page has been updated",
    "next": "Your action was not sent. To take over, press [Take over]."
  },
  "filter": {
    "all": "All",
    "unclaimed": "Unclaimed",
    "mine": "Mine",
    "org": "Organization",
    "org_label": "Organization: {{label}}",
    "org_all": "All organizations",
    "org_n": "{{n}} organizations",
    "org_unnamed": "Customer organization",
    "org_clear": "Clear organization filter",
    "org_max": "Select up to {{n}} organizations"
  },
  "overview": {
    "it_blocks": "IT monitoring",
    "incidents_title": "Incidents to handle now",
    "sev_n_P1": "Urgent {{n}}",
    "sev_n_P2": "Important {{n}}",
    "sev_n_P3": "Normal {{n}}",
    "filter": "Filter incidents",
    "see_all": "View all {{n}}",
    "none_watching": "Nothing to handle right now · watching {{homes}} $t(translation:leaf.cur_lc_pl)",
    "none_filtered": "No matching incidents",
    "incidents_unavailable": "Can't load incidents; other sections work as usual.",
    "homes_title": "$t(translation:leaf.cur) status",
    "homes_n": "{{n}} $t(translation:leaf.cur_lc_pl)",
    "homes_counts": "$t(translation:leaf.cur_pl) by status",
    "homes_unavailable": "Can't load $t(translation:leaf.cur_lc) status; other sections work as usual.",
    "others_ok": "The other {{n}} are OK",
    "homes_more": "{{n}} more; see the incident list",
    "none_watching_hosts": "Nothing to handle right now · watching {{homes}} $t(translation:leaf.cur_lc_pl) and {{hosts}} computers",
    "orgs_homes_n": "{{orgs}} organizations · {{n}} $t(translation:leaf.cur_lc_pl)",
    "org_p1_unclaimed": "Unclaimed urgent {{n}}",
    "org_bad_homes": "{{n}} $t(translation:leaf.cur_lc_pl) failing",
    "org_unreadable_homes": "{{n}} $t(translation:leaf.cur_lc_pl) unreadable",
    "org_open": "Open incidents {{n}}",
    "org_hosts_offline": "Offline hosts {{n}}",
    "orgs_others_ok": "{{n}} other organizations are OK",
    "orgs_more": "{{n}} more organizations — see the incident list"
  },
  "live": {
    "on_s": "Live · updated {{n}} s ago",
    "on_m": "Live · updated {{n}} min ago",
    "off": "Disconnected · last update {{time}}",
    "stale_bar": "Updates stopped {{n}} min ago: this is the status at {{time}}; there may be new incidents.",
    "reconnect": "Reconnect"
  },
  "incidents": {
    "tabs": "Incident tabs",
    "tab_open": "Open",
    "tab_open_n": "Open ({{n}})",
    "tab_all": "All",
    "none_open": "No open incidents",
    "none": "No incidents yet",
    "none_filtered": "No matching incidents",
    "clear_filter": "Clear filter",
    "see_all": "View all incidents",
    "load_more": "Load more",
    "shown_all": "Showing all {{n}}",
    "unavailable": "Can't load incidents"
  },
  "enable_card": {
    "title": "Use {{console}} to watch the network and computers of {{org}}",
    "body": "When a switch goes down, a server stops or a disk is failing, you are told which $t(translation:leaf.cur_lc), whether recording is affected, the likely cause and what to do. Only things that need action are shown.",
    "note": "Computers need \"{{agent}}\" installed. It only reports health data; it does not see screens, files or typing. A person responsible for {{org}} must accept the data processing agreement to turn this on.",
    "start": "Start",
    "later": "Later"
  },
  "org": {
    "title": "IT monitoring",
    "crumb_org": "Organization settings",
    "enable_title": "Turn on IT monitoring",
    "enable_crumb": "Turn on",
    "tabs": "IT monitoring tabs",
    "tab_status": "Turn on",
    "tab_oncall": "On-call schedules",
    "tab_keys": "Admin passkeys",
    "no_admin": "Only organization owners and admins can set up IT monitoring.",
    "dpa": "Data processing agreement",
    "dpa_accepted": "Accepted version {{v}} ({{time}})",
    "dpa_none": "Not accepted yet",
    "homes": "Watched $t(translation:leaf.cur_lc_pl)",
    "homes_none": "None yet",
    "home_settings": "Monitoring settings",
    "start_wizard": "Start setup",
    "open_wizard": "Add $t(translation:leaf.cur_lc_pl) or create a deployment token",
    "manage": "Settings",
    "card_enabled": "Watching {{n}} $t(translation:leaf.cur_lc_pl) · on-call schedules and setup are here",
    "card_none": "Not turned on. Use it to watch the network and computers of your $t(translation:leaf.cur_lc_pl).",
    "tab_templates": "Monitoring templates",
    "tab_handover": "Handover",
    "tab_built": "Customers you set up"
  },
  "keys": {
    "intro": "The management app on each computer only accepts security policies signed by a signing passkey on this list. Adding needs confirmation by one on the list on the signing page; removing needs no signature, but all deployment tokens the organization created before become invalid.",
    "unavailable": "Can't load the admin list ({{detail}}).",
    "current": "Current list (version {{v}})",
    "empty": "The list is empty: nobody can sign security policies yet. The first one added needs no signature; only deployment tokens created afterwards carry the new list.",
    "you": "You",
    "stale": "Account or passkey no longer exists; remove it",
    "remove_replaced": "Remove (replaced device)",
    "remove_lost": "Remove (lost or stolen)",
    "confirm_title": "Remove {{who}}'s passkey {{id}}",
    "confirm_tokens": "After removal, {{n}} deployment tokens created before become invalid (enrolled computers are not affected):",
    "confirm_no_tokens": "No deployment tokens will become invalid.",
    "token_line": "{{name}} · {{n}} computers not yet enrolled",
    "confirm_remove": "Remove now ({{n}} tokens become invalid)",
    "candidates": "Signing passkeys you can add",
    "no_candidates": "None. They appear here after an owner or admin creates a signing passkey in step ⓪ of the setup wizard.",
    "add_anchor": "Add",
    "add_sign": "Add (sign with my passkey)",
    "need_listed": "An admin already on the list must add you; your own signing passkey isn't on the list yet.",
    "reinstall_title": "The admin list cannot be updated on {{n}} computers",
    "reinstall_body": "The list was emptied and set up again, so these computers reject the new list by design; remote assistance and signed auto actions will be refused. Reinstall the management app on them with a new deploy token (it carries the current list); the old entry is replaced after reinstalling.",
    "reinstall_reanchor": "has list v{{v}}; the list was set up again after that",
    "reinstall_rejected": "the computer rejected the new list ({{code}})",
    "reinstall_token": "Create a new deploy token",
    "reinstall_token_home": "Create a new deploy token · {{home}}"
  },
  "wizard": {
    "steps": "Setup steps",
    "done_sr": "(done)",
    "step_0": "Passkey",
    "step_1": "Data processing agreement",
    "step_2": "$t(translation:leaf.cur_pl)",
    "step_5": "Deployment token",
    "title_0": "Make sure you have a passkey",
    "title_1": "IT monitoring data processing agreement",
    "title_2": "Choose $t(translation:leaf.cur_lc_pl) to watch",
    "title_5": "Create a deployment token",
    "next_0": "Next: agreement",
    "next_1": "Next: $t(translation:leaf.cur_lc_pl)",
    "next_5": "Done",
    "prev": "Back",
    "skip": "Skip this step",
    "save_leave": "Save and leave",
    "skip_finish": "Skip, create later",
    "finish": "Done, back to IT monitoring",
    "progress": "Setup progress {{n}} / {{total}}",
    "progress_note": "You can skip any step and continue later under Organization settings › IT monitoring.",
    "denied": "Only organization owners and admins can turn this on",
    "denied_body": "Ask an owner or admin of {{org}} to turn it on.",
    "status_unavailable": "Can't read the IT monitoring status ({{detail}}).",
    "passkey_ok": "You already have {{n}} signing passkeys.",
    "passkey_need": "Changing the computers' administrator list and signing security policies require a signing passkey (created on the separate signing page, apart from your sign-in passkeys; verification codes don't count).",
    "passkey_readonly": "Until you register a passkey, IT monitoring security settings are read-only for you.",
    "passkey_add": "Create a signing passkey",
    "passkey_no_sign": "The signing page isn't available in this environment yet, so a signing passkey can't be created.",
    "passkey_sign_note": "A new window (the signing page) opens; confirm there.",
    "passkey_name": "IT monitoring",
    "passkey_unsupported": "This browser doesn't support passkeys; use another browser or register on your phone.",
    "passkey_err": "Registration failed ({{code}}).",
    "dpa_version": "Version {{v}}",
    "dpa_summary": "Summary",
    "dpa_s1": "{{org}} is the data controller; the service provider is the processor.",
    "dpa_s2": "Collects health data of computers and network devices (CPU, memory, disks, whether services run, total traffic); no screens, file contents or keystrokes.",
    "dpa_s3": "Retention: metrics 24 months (aggregated), incidents 13 months, audit at least 1 year; deleted 30 days after termination.",
    "dpa_full": "Full text",
    "dpa_accept": "On behalf of {{org}}, I accept the IT monitoring data processing agreement (version {{v}})",
    "dpa_accepted": "Accepted version {{v}} ({{time}}).",
    "dpa_updated": "The agreement was just updated to version {{v}}; please read it again before accepting.",
    "before_dpa": "What you can do before accepting",
    "before_dpa_body": "You can choose $t(translation:leaf.cur_lc_pl), create deployment tokens and install \"{{agent}}\" on computers; they start reporting once the agreement is accepted, no reinstall needed.",
    "need_dpa": "Accept the data processing agreement first to turn on $t(translation:leaf.cur_lc_pl).",
    "to_dpa": "Go to the agreement",
    "homes_intro": "Chosen $t(translation:leaf.cur_lc_pl) are watched. In $t(translation:leaf.cur_lc_pl) with IT monitoring, device offline and recording interruptions are notified as incidents (one notification per problem).",
    "homes_none": "This organization has no $t(translation:leaf.cur_lc_pl) yet.",
    "home_enabled": "On",
    "enable": "Turn on {{n}} $t(translation:leaf.cur_lc_pl)",
    "need_homes": "Turn on at least one $t(translation:leaf.cur_lc) before creating a deployment token.",
    "to_homes": "Choose $t(translation:leaf.cur_lc_pl)",
    "token_side": "Creating a token asks you to confirm your identity again; the token is shown only once."
  },
  "token": {
    "name": "Name",
    "home": "$t(translation:leaf.cur) to enroll into",
    "default_name": "{{home}} first batch",
    "expiry": "Valid for",
    "days": "{{n}} days (until {{until}})",
    "expiry_hint": "Up to 30 days. Computers not installed by then need a new token.",
    "max": "Maximum computers (required)",
    "max_hint": "Computers beyond your licensed count start unlicensed and are licensed in enrollment order once you buy more.",
    "max_bad": "Enter a whole number from 1 to 10000.",
    "cidrs": "Only allow enrollment from these networks (optional)",
    "cidrs_hint": "Computers installed on other networks are blocked and retry automatically on the company network.",
    "cidrs_bad": "Not network ranges: {{list}}",
    "ownership": "Who owns these computers",
    "own_org": "Organization",
    "own_byod": "Employee",
    "ownership_hint": "You can change each computer later on the host page.",
    "expected": "Expected list (optional)",
    "expected_hint": "Import a CSV or an AD export of computer names; the progress page lists those not enrolled yet.",
    "expected_n": "Read {{n}} computer names.",
    "once_note": "You'll confirm your identity again; the token is shown only once.",
    "create": "Confirm and create",
    "new": "Create deployment token…",
    "new_title": "Create deployment token",
    "once_title": "Shown only this once",
    "once_body": "You can't see it again after leaving this page. Copy it into your install settings or download it as a file.",
    "copy": "Copy token",
    "copied": "Copied",
    "download": "Download token file",
    "once_meta": "{{name}} · {{home}} · up to {{n}} · until {{until}}",
    "install_title": "Install \"{{agent}}\"",
    "install_1": "Install \"{{agent}}\" on the computers to watch.",
    "install_2": "Put the token file on that computer (readable by administrators only) and point the installer at it; never put the token on the command line.",
    "install_3": "Once installed, \"{{agent}}\" enrolls automatically; open \"{{agent}}\" on that computer to see what it collects.",
    "install_note": "Don't put the token in a share everyone can read: that hands the token to everyone who can see it.",
    "after_title": "After installing",
    "after_body": "Watch each computer's status and failure reasons live on the enrollment progress page.",
    "see_progress": "View enrollment progress",
    "state_active": "Active",
    "state_expired": "Expired",
    "state_exhausted": "Used up",
    "state_revoked": "Invalid",
    "col_state": "Status",
    "col_progress": "Enrollment",
    "col_expires": "Expires",
    "progress_short": "Enrolled {{a}} / {{n}} · failed {{f}}",
    "list_unavailable": "Can't load deployment tokens",
    "none": "No deployment tokens yet",
    "none_body": "Create a token and use it when installing; the computer then enrolls into this $t(translation:leaf.cur_lc).",
    "unavailable": "Can't load this token",
    "revoke_btn": "Revoke…",
    "revoke_title": "Revoke \"{{name}}\"",
    "revoke_body": "The {{n}} computers not enrolled yet will fail to enroll; already enrolled computers are not affected.",
    "revoke": "Revoke token",
    "revoked_manual": "This token was revoked ({{time}}); computers not enrolled yet need a new token.",
    "revoked_admin_removed": "This token is no longer valid ({{time}}): someone was removed from the administrator list. Create a new token and replace the old one in your install settings.",
    "revoked_creator_left": "This token is no longer valid ({{time}}): its creator left the organization. Create a new token and replace the old one in your install settings.",
    "revoked_rebuilt": "This token was replaced by a new one ({{time}}).",
    "expired_bar": "This token expired at {{time}}; computers not installed yet need a new token.",
    "kpi_approved": "Enrolled",
    "kpi_failed": "Failed",
    "kpi_remaining": "Not enrolled yet",
    "kpi_remaining_note": "Computers that never sent an enrollment are invisible to the cloud",
    "failed_title": "Failed ({{n}})",
    "col_host": "Computer",
    "col_reason": "Reason and what you can do",
    "col_os": "Operating system",
    "col_ip": "Source IP",
    "col_time": "Time",
    "failed": "Failed",
    "notyet_title": "Not enrolled yet ({{n}})",
    "notyet_expected": "Not enrolled per the expected list: {{list}}{{more}}",
    "and_more": " and {{n}} more",
    "notyet_hint": "Computers silent for over an hour may not have installed (install settings not applied yet, computer off, blocked by antivirus); the reason is only visible on that computer.",
    "ok_title": "Enrolled ({{n}})",
    "ok_none": "No computers enrolled yet.",
    "unexpected": "Not on the expected list",
    "kpi_pending": "Waiting for you",
    "rebuild_btn": "Rebuild…",
    "rebuild_title": "Rebuild \"{{name}}\"",
    "rebuild": "Verify and rebuild",
    "rebuild_body": "Keeps the $t(translation:leaf.cur_lc), source networks, ownership and expected list, and binds the current admin list; the limit is the {{n}} computers that have not enrolled yet. The new token is shown only once — replace the old token in your install settings (GPO script, Intune, RMM). Until then, computers that have not enrolled keep retrying with the old token and keep failing, so the incident count goes up; enrolled computers are not affected.",
    "rebuilt_note": "This is the rebuilt token; the old one has been replaced. Put the install parameters below into your GPO script, Intune or RMM."
  },
  "enroll": {
    "todo_prefix": "What you can do: ",
    "reason_expired": "Token expired",
    "todo_expired": "Create a new token and replace the old one in your install settings.",
    "reason_exhausted": "Computer limit reached",
    "todo_exhausted": "Create a new token, or ask an administrator to raise the limit.",
    "reason_revoked": "Token no longer valid",
    "todo_revoked": "Ask the creator or the managing installer to create a new token and replace the old one in your install settings.",
    "reason_source": "Source network not allowed",
    "todo_source": "It retries automatically on the company network; or add the network range to the token.",
    "reason_dpa": "Data processing agreement not accepted yet",
    "todo_dpa": "After the agreement is accepted, computers retry every 15 minutes; no reinstall needed.",
    "reason_clock": "Computer clock is too far off",
    "todo_clock": "Correct this computer's time; it retries automatically.",
    "reason_hw": "This computer's hardware identity does not match",
    "todo_hw": "It may be a cloned system image; reinstall on that computer.",
    "reason_invalid": "Wrong token",
    "todo_invalid": "Make sure the whole token string is in your install settings.",
    "reason_other": "Enrollment failed",
    "todo_other": "Check the error code under Details, or open the manager on that computer to see why.",
    "reason_host_rejected": "Rejected",
    "todo_host_rejected": "This computer will be refused with this token from now on. To add it, rebuild the token and reinstall with the new one."
  },
  "home_settings": {
    "title": "Monitoring settings",
    "crumb_sites": "Organization & sites",
    "tabs": "Monitoring settings tabs",
    "tab_tokens": "Deployment tokens",
    "tab_notify": "Notifications",
    "tokens_intro": "Computers installed with a deployment token enroll into this $t(translation:leaf.cur_lc).",
    "not_found": "$t(translation:leaf.cur) not found",
    "back_sites": "Back to Organization & sites",
    "not_enabled": "IT monitoring is not on for this $t(translation:leaf.cur_lc) yet; you can create tokens now, computers start reporting once it is on.",
    "no_org": "This $t(translation:leaf.cur_lc) does not belong to an organization, so it has no on-call schedule.",
    "unavailable": "Can't load monitoring settings",
    "tab_collectors": "Collectors",
    "tab_thresholds": "Thresholds & levels",
    "tab_probes": "Probes",
    "tab_windows": "Maintenance & business hours",
    "tab_site": "Site info"
  },
  "notify": {
    "schedule": "On-call schedule",
    "no_schedule": "No schedule",
    "no_schedule_hint": "Without a schedule, urgent incidents go to the $t(translation:leaf.cur_lc)'s owners and admins.",
    "schedule_hint": "Urgent incidents go at minute 0 to whoever is on call; gaps go straight to the on-call supervisor.",
    "contact": "Customer contact",
    "contact_default": "Default: organization owner {{name}}",
    "contact_default_none": "Default: organization owner",
    "contact_hint": "When neither the on-call person nor the supervisor can be reached, urgent incidents go to this person.",
    "channels": "Channels: app push (time-sensitive for urgent incidents) and email; no SMS or voice calls.",
    "save_note": "Changing notification settings asks you to confirm your identity and notifies the owners and admins of this $t(translation:leaf.cur_lc)'s organization.",
    "save": "Save",
    "saved": "Saved.",
    "edit_schedules": "Edit on-call schedules"
  },
  "oncall": {
    "intro": "$t(translation:leaf.cur_pl) point to a schedule, not to people; the next person takes over every Monday 00:00 (schedule time zone).",
    "new": "New schedule",
    "none": "No on-call schedules yet",
    "none_body": "Without a schedule, urgent incidents go to the $t(translation:leaf.cur_lc)'s owners and admins.",
    "unavailable": "Can't load on-call schedules",
    "name": "Name",
    "now_on": "On call now",
    "nobody_now": "Nobody on call → goes to {{name}}",
    "supervisor": "On-call supervisor",
    "supervisor_hint": "Gets it when nobody presses [I'll handle it] within 15 minutes; also gets gaps directly.",
    "used_by": "Used by",
    "homes_n": "{{n}} $t(translation:leaf.cur_lc_pl)",
    "edit_title": "Edit schedule",
    "not_found": "Schedule not found",
    "back": "Back to schedules",
    "tz": "Time zone",
    "rotation_start": "Rotation start",
    "rotation_start_hint": "The first person on the list is on call the week of this date.",
    "slot_title": "Time slot and rotation",
    "slot_name": "Slot name",
    "slot_default": "All day",
    "time": "Time",
    "start": "Start",
    "end": "End",
    "time_hint": "Same start and end = all day; end before start = overnight.",
    "days": "Days",
    "gap": "Nobody is on call at other times: urgent incidents go straight to supervisor {{name}} (the customer is not woken).",
    "rotation": "Weekly rotation",
    "rotation_empty": "Nobody yet. Add at least one person.",
    "this_week": "this week",
    "next_week": "next week",
    "up": "Move {{name}} up",
    "down": "Move {{name}} down",
    "remove": "Remove {{name}} from the rotation",
    "remove_short": "Remove",
    "add_person": "Person to add to the rotation",
    "add": "Add",
    "pick": "Choose a member",
    "summary": "This week ({{slot}}): {{now}} · supervisor {{sup}} · next week: {{next}}",
    "summary_empty": "The list is empty: urgent incidents in this slot go straight to the supervisor.",
    "save_note": "Saving asks you to confirm your identity; the organizations of $t(translation:leaf.cur_lc_pl) using this schedule are notified.",
    "save": "Save schedule",
    "err_name": "Enter a name",
    "err_supervisor": "Choose an on-call supervisor",
    "err_days": "Choose at least one day",
    "err_time": "Times must be HH:MM",
    "err_rotation": "The rotation needs at least one person",
    "err_conflict": "Someone just changed this schedule; reload and try again."
  },
  "day": {
    "1": "Mon",
    "2": "Tue",
    "3": "Wed",
    "4": "Thu",
    "5": "Fri",
    "6": "Sat",
    "7": "Sun"
  },
  "err": {
    "default": "Something went wrong ({{code}}).",
    "NETWORK": "Can't reach the service; check your network and retry.",
    "NO_SESSION": "Your sign-in expired; please sign in again.",
    "UNAUTHORIZED": "Your sign-in expired; please sign in again.",
    "FORBIDDEN": "You don't have permission for this.",
    "NOT_FOUND": "Not found; it may have been deleted or you lack access.",
    "UNAVAILABLE": "The service is temporarily unavailable; try again later.",
    "RATE_LIMITED": "Too many attempts; try again later.",
    "REAUTH_REQUIRED": "Confirm your identity first.",
    "PASSKEY_REQUIRED": "This needs a passkey; register one under My account › Security first.",
    "KMGR_REGION_UNSUPPORTED": "IT monitoring is not offered in this organization's region.",
    "KMGR_DPA_REQUIRED": "Accept the IT monitoring data processing agreement first.",
    "INVALID_ARGUMENT": "Something in the data is wrong; check and retry.",
    "INVALID_TRANSITION": "This incident can't be changed that way from its current state.",
    "INCIDENT_STATE_CONFLICT": "Someone just changed this incident.",
    "CONFLICT": "Someone just changed this; reload and try again.",
    "FEATURE_DISABLED": "This feature is not on in this environment.",
    "KMGR_STOPPED": "IT monitoring is paused by the organization.",
    "HANDOVER_INCOMPLETE": "The handover of this organization is not complete yet",
    "ORG_LIMIT": "You have reached the organization limit"
  },
  "cause": {
    "service_stopped": "{{subject}} stopped on {{target}}",
    "host_offline": "{{target}} is offline",
    "other": "Problem on {{target}}",
    "disk_full": "{{subject}} on {{target}} is almost full",
    "power_outage": "Power outage",
    "ups_output_off": "{{target}} output off",
    "ups_overload": "{{target}} overloaded",
    "ups_battery": "{{target}} battery needs attention",
    "poe_budget": "{{target}} PoE power over threshold",
    "poe_denied": "{{target}} PoE power denied"
  },
  "home_reason": {
    "incidents": "{{n}} ongoing incidents",
    "unreadable_since": "No computer is responding · last report {{time}}",
    "unreadable_never": "No computer has reported yet",
    "unset": "No computer has enrolled yet",
    "watching": "Watching {{n}} computers",
    "collector_offline": "Collector {{name}} offline for {{n}} min",
    "snmp_auth": "Network device SNMP authentication failed",
    "maintenance_by": "Maintenance set by {{name}}"
  },
  "ev_text": {
    "opened": "Incident opened: {{cause}}",
    "recurred": "Same cause happened again; merged into this incident",
    "recovered": "Recovered",
    "auto_resolved": "Recovered for 24 hours with no one handling it; closed by the system",
    "notify_opened": "Push sent to {{who}}",
    "notify_resolved": "Recovery notice (silent) sent to {{who}}",
    "home_admins": "$t(translation:leaf.cur_lc) owners and admins"
  },
  "dur": {
    "minutes": "{{n}} min",
    "hours": "{{n}} h",
    "days": "{{n}} days"
  },
  "global_stop": {
    "title": "Kinio has paused all automatic actions and remote assistance (since {{time}})",
    "scope_all": "All organizations are affected; monitoring, incidents and notifications continue. Only Kinio can resume — there is no resume button here.",
    "scope_org": "This organization is affected; monitoring, incidents and notifications continue. Only Kinio can resume."
  },
  "host": {
    "online": "Online",
    "offline": "Offline",
    "offline_for": "Offline {{for}}",
    "shutdown": "Shut down · {{time}}",
    "sleep": "Sleeping",
    "away": "Away · {{for}}",
    "updating": "Updating · {{n}} min",
    "suspended": "Suspended (clone)",
    "revoked": "Revoked",
    "unknown": "Unknown",
    "unlicensed": "Unlicensed",
    "is_collector": "Collector",
    "critical": "Critical host",
    "critical_hint": "Offline or a registered service stopping counts as urgent (3-minute debounce).",
    "local_paused": "Paused locally ({{by}} {{time}})",
    "local_paused_bar": "{{by}} paused automatic actions and remote assistance on this computer at {{time}} (this computer only); monitoring continues.",
    "key_hw": "Security chip",
    "key_sw": "No hardware protection",
    "metric_cpu": "CPU",
    "metric_mem": "Memory",
    "metric_disk": "Disk",
    "disk_mount": "Disk {{mount}}",
    "primary_user": "Primary user {{name}}",
    "not_found": "This computer can't be found",
    "not_found_body": "It may have been removed, or you no longer have access to this $t(translation:leaf.cur_lc).",
    "back_list": "Back to hosts",
    "tabs": "Host tabs",
    "tab_overview": "Overview",
    "tab_telemetry": "What is reported",
    "this_pc": "This computer",
    "class_seat": "{{cls}} (seat: {{cls}})",
    "last_seen": "Last report",
    "collector_scan": "Scannable subnets",
    "collector_none": "No subnets assigned yet",
    "collector_error": "Collector reported an error: {{code}}",
    "settings_title": "Monitoring settings for this host",
    "expected_offline": "Expected offline hours",
    "expected_offline_hint": "No incident and not counted as offline inside these hours; servers have none by default.",
    "expected_offline_ws": "Workstation default: shutting down after work or sleeping is not offline; only listed as Normal after 7 days without contact. You can add fixed hours too.",
    "expected_offline_none": "None",
    "save_note": "Changes to this host are audited.",
    "saved": "Saved.",
    "primary_user_label": "Primary user",
    "primary_user_hint": "Used for search and display (also shown while waiting for remote assistance). Pick an organization member or type a name; sign-in accounts are not collected.",
    "primary_user_ph": "e.g. Mia Wang · Accounting",
    "primary_user_member": "Organization members"
  },
  "hosts": {
    "tabs": "Host tabs",
    "tab_all": "All",
    "tab_all_n": "All ({{n}})",
    "tab_enrolling": "Enrolling",
    "tab_unlicensed": "Unlicensed",
    "tab_unlicensed_n": "Unlicensed ({{n}})",
    "filter_state": "Status",
    "state_any": "Status: all",
    "state_online": "Online",
    "state_offline": "Offline",
    "state_expected_offline": "Expected offline",
    "state_suspended": "Suspended",
    "state_revoked": "Revoked",
    "filter_class": "Class",
    "class_any": "Class: all",
    "only_issues": "With issues",
    "unavailable": "Can't read the host list",
    "none": "No computers have enrolled yet",
    "none_body": "Create a deployment token and install the management program; computers appear here.",
    "none_filtered": "No matching computers",
    "shown_all": "All {{n}} shown",
    "footnote": "Numbers are colored only when abnormal; “shut down / sleeping / updating / away” is expected offline and opens no incident.",
    "col_name": "Name",
    "col_home": "$t(translation:leaf.cur)",
    "col_org_home": "Organization › $t(translation:leaf.cur_lc)",
    "col_class": "Class",
    "col_state": "Status",
    "col_metrics": "CPU · memory · disk",
    "col_version": "Program version",
    "col_key": "Key protection",
    "col_since": "Enrolled",
    "col_actions": "Actions",
    "enrolling_none": "No tokens still enrolling",
    "enrolling_none_body": "Active deployment tokens are used up or not created yet; create one and use it when installing.",
    "unlicensed_none": "No unlicensed computers",
    "unlicensed_none_body": "There are enough seats.",
    "unlicensed_bar": "{{n}} unlicensed:",
    "unlicensed_body": "They only report online status and basic info: no metrics, no incidents, no remote assistance, local rules stopped. Once seats run out, later enrollments become unlicensed first; computers already watched are never kicked out.",
    "unlicensed_need_admin": "Reassigning or buying seats is for the organization owner or admin.",
    "reason_released": "Seat reassigned to another computer",
    "search": "Search name or primary user",
    "search_none": "No computers match “{{q}}”"
  },
  "seat": {
    "server": "Server",
    "workstation": "Workstation",
    "summary_title": "Seats",
    "available_n": "{{n}} available",
    "all_used": "All in use",
    "buy": "Buy more…",
    "need_billing": "Buying seats needs billing permission; ask the owner ({{name}}).",
    "owner_role": "owner",
    "reassign_hint": "You can also reassign a licensed computer (e.g. a leaver's laptop) to one of these.",
    "reassign_btn": "Reassign seat…",
    "reassign_title": "Reassign a seat to {{host}}",
    "reassign_body": "Pick a seat for this computer; the computer holding it becomes unlicensed.",
    "pick": "Pick a seat",
    "option_assigned": "{{host}} (since {{time}})",
    "option_free": "Free seat",
    "no_seats": "No seats of this class.",
    "reassign_warn": "{{host}} will become unlicensed.",
    "reassign_ok": "Reassign"
  },
  "net": {
    "title": "Network & hosts",
    "hosts_n": "{{n}} computers",
    "unavailable": "Can't read hosts and network; other blocks are unaffected.",
    "unreadable": "Can't read network devices",
    "unreadable_collector": "Can't read network devices (collector {{name}} offline {{for}})",
    "and_more": ", {{n}} more",
    "unreadable_auth": "Can't read network devices (SNMP authentication failed)",
    "unreadable_note": "switches and APs are not in these numbers",
    "see_collectors": "View collectors",
    "collector_unnamed": "collector",
    "row_network_down": "Network devices not responding (WAN / switch / AP)",
    "row_servers_offline": "Servers offline",
    "row_collectors_offline": "Collectors offline",
    "row_devices_offline": "Devices offline",
    "row_storage_faults": "Recorder storage faults",
    "row_recording_gaps": "Cameras with recording gaps (24 h)",
    "n_network_down": "{{n}}",
    "n_servers_offline": "{{n}}",
    "n_collectors_offline": "{{n}}",
    "n_devices_offline": "{{n}}",
    "n_storage_faults": "{{n}}",
    "n_recording_gaps": "{{n}}",
    "n": "{{n}}",
    "n_hosts": "{{n}}",
    "others_ok": "{{n}} other items OK",
    "all_ok": "All {{n}} items OK",
    "hosts_line": "Computers: {{online}} online · {{expected}} expected offline",
    "todo_title": "Setup to-do",
    "todo_note": "not faults, not counted in $t(translation:leaf.cur_lc) status",
    "todo_unlicensed": "Unlicensed computers",
    "tabs": "Network & apps tabs",
    "tab_devices": "Network devices",
    "tab_devices_n": "Network devices ({{n}})",
    "tab_probes": "App probes",
    "tab_probes_n": "App probes ({{n}})",
    "tab_collectors": "Collectors",
    "tab_collectors_n": "Collectors ({{n}})",
    "no_homes": "No monitored $t(translation:leaf.cur_lc_pl) in this scope",
    "no_homes_body": "Change the scope or enable IT monitoring first.",
    "partial_failed": "{{n}} $t(translation:leaf.cur_lc_pl) can't be read; the rest are unaffected.",
    "col_name": "Name",
    "col_addr": "Address",
    "col_method": "Read via",
    "col_ifs": "Interfaces",
    "col_poe": "PoE",
    "col_temp": "Temperature",
    "col_collector": "Collector",
    "col_target": "Target",
    "col_kind": "Kind",
    "col_last": "Last check",
    "col_scan": "Subnets",
    "col_applied": "Config applied",
    "method_snmp": "SNMP read-only",
    "method_ping": "Ping only",
    "ok_snmp": "Readable",
    "ok_snmp_n": "Readable · {{n}} interfaces",
    "ok_ping": "Responding",
    "ok_probe": "OK",
    "bad_snmp": "Read failed (code {{code}})",
    "bad_ping": "Not responding",
    "bad_probe": "Failed (code {{code}})",
    "unassigned": "No collector assigned",
    "noresult": "No result yet",
    "ifs_down": "{{n}} ({{down}} down)",
    "ifs_n": "{{n}} interfaces",
    "devices_note": "Discovered Kinio devices are on the Devices page, not here; interfaces, PoE and temperature appear when the collector can read them.",
    "devices_none": "No network devices yet",
    "devices_none_body": "Make a computer the collector and give it subnets, then add switches, routers and firewalls.",
    "probes_none": "No app probes yet",
    "probes_none_body": "Use HTTP / TCP / file-freshness probes to see whether services are running.",
    "collectors_none": "No collectors yet",
    "collectors_none_body": "A collector is a computer in the $t(translation:leaf.cur_lc) with the management program that reads network devices and runs probes.",
    "setup_collector": "Set up a collector",
    "setup_probe": "Add a probe",
    "applied_v": "Applied v{{v}}",
    "pending_v": "Pending v{{v}} (now v{{cur}})",
    "row_disks_full": "Disks almost full",
    "n_disks_full": "{{n}}",
    "by_org_title": "By organization",
    "org_net_down": "Network devices not responding {{n}}",
    "org_unreadable": "Network devices unreadable",
    "org_servers_offline": "Servers offline {{n}}",
    "org_disks_full": "Disks almost full {{n}}",
    "org_collectors_offline": "Collectors offline {{n}}",
    "orgs_others_ok": "{{n}} other organizations are OK",
    "orgs_more": "{{n}} more organizations have issues; filter by organization on the Hosts page",
    "row_ups_on_battery": "Power · UPS on battery",
    "n_ups_on_battery": "{{n}}",
    "row_ups_unreadable": "Power · UPS unavailable",
    "n_ups_unreadable": "{{n}}",
    "row_poe_over_warn": "PoE power over warning threshold",
    "n_poe_over_warn": "{{n}}",
    "todo_ups_no_downstream": "UPS without registered equipment",
    "n_ups": "{{n}}",
    "org_ups_on_battery": "UPS on battery {{n}}",
    "org_poe_over_warn": "PoE over threshold {{n}}",
    "tab_ups": "UPS",
    "tab_ups_n": "UPS {{n}}"
  },
  "collector": {
    "intro": "A collector is a computer in this $t(translation:leaf.cur_lc) with the management program: it reads switches, routers and firewalls (SNMP read-only or ping) and runs app probes. Credentials stay on the collector; the cloud can't see them.",
    "policy_scan": "Subnets allowed by organization policy: {{cidrs}}",
    "policy_none": "Organization policy allows no subnets yet: ask an organization admin to set it under Organization settings › IT monitoring › Security policy.",
    "none": "No collector yet",
    "none_body": "Pick an online computer to be the collector.",
    "add_device": "Add network device…",
    "need_collector": "A collector is needed before adding network devices.",
    "kinio_note": "Discovered Kinio devices (cameras, Kinio Station) are marked “already a Kinio device” and link to the device page; they are not created twice.",
    "title": "Collector",
    "scan": "Scannable subnets",
    "scan_hint": "One subnet per line (e.g. 10.20.0.0/16); must be within the organization policy.",
    "saved": "Saved; applied when the collector is online.",
    "err_scan": "{{target}} is outside the subnets the organization allows.",
    "save_scan": "Save subnets",
    "local_note": "The collector must also be enabled locally (management program settings); otherwise an error shows here.",
    "pick": "Which computer",
    "make": "Make it the collector"
  },
  "probe": {
    "intro": "Probes are checked by the collector on a schedule: HTTP (status code, keyword, certificate expiry), TCP port, file freshness (did the job run). Response content is never collected.",
    "add": "Add probe…",
    "add_title": "Add probe",
    "edit": "Edit…",
    "edit_title": "Edit probe",
    "kind_ping": "ping",
    "kind_snmp": "SNMP",
    "kind_http": "HTTP",
    "kind_tcp": "TCP port",
    "kind_file": "File freshness",
    "host": "Host name or address",
    "port": "Port",
    "scheme": "Scheme",
    "path": "Path",
    "keyword": "Keyword (optional)",
    "http_hint": "Only status 200 and the keyword are checked, latency measured and certificate expiry read; redirects are not followed.",
    "file": "File path",
    "file_hint": "Only the last-modified time of this file on the collector (incl. network paths) is read, never its content.",
    "credential": "Credential reference",
    "credential_hint": "SNMP needs a credential already on the collector (set by an admin on the collector; the cloud never sees it).",
    "interval": "Check interval",
    "every_s": "Every {{n}} s",
    "collector_auto": "Automatic (by subnet)",
    "err_target": "Enter the target address",
    "err_port": "Port must be 1–65535",
    "err_path": "Path must start with /",
    "err_file": "Enter the file path",
    "err_collector_offline": "The collector is offline, so the test can't run; check that it is online first.",
    "err_collector_disabled": "Collection is not enabled locally on the collector.",
    "test": "Test connection",
    "test_ok": "Reachable",
    "tls_days": "certificate expires in {{n}} days",
    "test_timeout": "No response (timeout)",
    "test_unreachable": "Unreachable",
    "test_auth_failed": "Authentication failed: wrong user name or password",
    "test_credential_missing": "No credentials",
    "test_tls_error": "Certificate problem",
    "test_dns": "Name resolution failed",
    "test_unexpected": "Unexpected response",
    "test_not_allowed": "Target outside the allowed range",
    "test_collector_error": "Collector error",
    "test_failed": "Failed",
    "create": "Create",
    "delete": "Delete…",
    "delete_title": "Delete “{{name}}”",
    "delete_body": "Its checks and alerts are cleared with it.",
    "none_body": "Add a probe to see whether a service is running."
  },
  "threshold": {
    "intro": "Level and debounce (how long before an incident opens) for each condition; changes affect only this $t(translation:leaf.cur_lc). Debounce can only be longer than the default; conditions that affect recording cannot be turned off.",
    "col_condition": "Condition",
    "col_severity": "Level",
    "col_debounce": "Debounce",
    "rule_home_unreachable": "$t(translation:leaf.cur) unreachable",
    "rule_camera_not_recording": "Camera not recording",
    "rule_recorder_storage": "Recorder disk failure or zero recording space",
    "rule_critical_host": "Critical host offline or service stopped",
    "rule_network_device": "Switch / router / WAN not responding",
    "rule_server_offline": "Server offline or service stopped; collector offline",
    "rule_disk_tls_probe": "Disk nearly full, SMART warning, TLS expiring, probe failing",
    "rule_unreadable": "Can't read (collector or management program lost)",
    "rule_enroll_failed": "New computer failed to enroll",
    "rule_workstation_offline": "Workstation offline past the limit",
    "changed": "changed",
    "immediate": "Immediately",
    "minutes": "{{n}} min",
    "no_incident": "No incident",
    "disk_pct": "Disk nearly full (%)",
    "tls_days": "TLS expiring within (days)",
    "ws_days": "Workstation offline days before listing",
    "err_disk": "Disk threshold must be 50–99",
    "err_tls": "TLS days must be 1–90",
    "err_ws": "Workstation days must be 7–90",
    "reset": "Restore defaults",
    "save_note": "Threshold changes are audited.",
    "saved": "Saved.",
    "updated": "Changed by {{name}} at {{time}}"
  },
  "maint": {
    "title": "Maintenance window",
    "inactive": "Not in maintenance now.",
    "set_by": "set by {{name}} at {{time}}",
    "active_note": "During maintenance no incidents, pushes or automatic actions; site notices for recording impact are still sent. Anything still wrong 5 minutes after it ends opens an incident.",
    "end": "End maintenance",
    "quick_label": "Quick maintenance",
    "extend_label": "Extend",
    "hours_n": "{{n}} h",
    "start": "Set maintenance for {{n}} h",
    "extend": "Extend",
    "quick_note": "Setting or extending re-verifies your identity and notifies the owner and admins of this $t(translation:leaf.cur_lc)'s organization; ending does not.",
    "schedule": "Scheduled maintenance",
    "schedule_none": "No schedule.",
    "save_note": "Setting or changing the schedule re-verifies your identity and notifies the customer.",
    "save_schedule": "Save schedule",
    "saved": "Saved.",
    "saved_notified": "Saved; {{n}} people notified.",
    "unchanged": "Nothing changed."
  },
  "biz": {
    "title": "Business hours",
    "intro": "Outside business hours, camera and workstation offline is lowered one level (still notified); ☾ shows next to the status.",
    "all_day": "Open all day (no hours set).",
    "save_note": "No re-verification; changes are audited.",
    "saved": "Saved."
  },
  "window": {
    "days": "Days",
    "start": "Start",
    "end": "End",
    "remove": "Remove",
    "add": "Add a window",
    "hint": "Same start and end = all day; end before start = past midnight.",
    "err_days": "Pick at least one day per window",
    "err_time": "Time must be hh:mm",
    "every_day": "Every day",
    "all_day": "all day"
  },
  "site": {
    "title": "Site info",
    "intro": "Shown at the top of the incident page; every change is audited.",
    "edit": "Edit",
    "collapse": "Collapse",
    "expand": "Expand",
    "customer": "Customer",
    "level_n": "Service level {{level}}",
    "until": "until {{date}}",
    "level_note": "Service level is display only and does not affect notifications: urgent incidents always follow the on-call schedule.",
    "contact": "Site contact",
    "call": "Call",
    "it_support": "IT support",
    "rack": "Rack",
    "access": "Access",
    "f_service_level": "Service level",
    "f_contract_until": "Contract ends",
    "f_contact_role": "Contact role",
    "f_contact_name": "Site contact",
    "f_contact_phone": "Phone",
    "f_it_support": "IT support phone & hours",
    "f_rack_note": "Rack notes",
    "f_access_note": "Access notes",
    "h_service_level": "Display only on the incident page; does not affect notifications.",
    "h_contact_phone": "Can be dialed from the incident page.",
    "h_it_support": "Shown on the employee help screen.",
    "ph_role": "Night security",
    "ph_it": "02-2345-6789 · Mon–Fri 08:30–18:00",
    "err_phone": "Phone may only contain digits, +, - and parentheses.",
    "save_note": "Anyone with monitoring settings permission can edit; every change is audited.",
    "saved": "Saved.",
    "preview": "Preview: incident page"
  },
  "telemetry": {
    "intro": "“{{agent}}” reports only the computer health below to {{org}}; it never looks at the screen, files or input.",
    "last_upload": "Last report {{time}}.",
    "item_cpu_mem_disk": "CPU / memory / disk",
    "desc_cpu_mem_disk": "Usage, per-disk fill level and SMART status",
    "item_net_bytes": "Network traffic totals",
    "desc_net_bytes": "Upload / download totals per interface; no connection destinations",
    "item_uptime_power": "Uptime · power state",
    "desc_uptime_power": "Time since boot, shutdown / sleep / update restart",
    "item_services": "Whether services run",
    "desc_services": "Only names and status of services the program discovered and registered",
    "item_os_update": "System updates",
    "desc_os_update": "Whether updates are pending",
    "item_event_log": "System event log",
    "desc_event_log": "Only rule-matched snippets; user names, emails and IPs masked; login names and security events not collected by default",
    "never_title": "Never collected",
    "never_cmdline": "command-line arguments",
    "never_window_title": "window titles",
    "never_files": "names of open files",
    "never_connections": "per-connection network destinations",
    "never_images": "camera video, thumbnails, snapshots",
    "local_page": "To see what this computer actually sent, open “{{agent}}” on it › “What was collected”."
  },
  "remote": {
    "screen_person": "the person at the screen",
    "your_org": "your organization",
    "list_sep": ", ",
    "dialog_title": "Remote assistance · {{host}}",
    "tabs": "Remote assistance tabs",
    "tab_requests": "Help requests",
    "tab_requests_n": "Help requests ({{n}})",
    "tab_records": "History",
    "form_lead": "{{name}} will see your name and “{{org}}” on their computer, and nothing starts until they click Allow. A red frame and a floating bar stay on their screen the whole time, and they can end it at any moment.",
    "not_admin": "{{name}} is not an administrator on this computer: windows that ask for an admin password (for example installing a driver) are hidden from you and you can't click them. Someone with an admin account must be there.",
    "perms_title": "Permissions they will be asked to allow",
    "perm": {
      "view": "View",
      "control": "Control",
      "clipboard": "Clipboard",
      "file_transfer": "File transfer"
    },
    "perm_hint": {
      "view": "See their screen (always included)",
      "control": "Use the mouse and keyboard",
      "clipboard": "Copy and paste text both ways",
      "file_transfer": "Send files to them; they can also pick files to send you"
    },
    "no_recording": "This session is not recorded.",
    "no_recording_short": "Not recorded",
    "reason": "Reason (goes into the history; they don't see it)",
    "reason_ph": "e.g. The printer keeps showing offline",
    "reason_assist": "Help code {{code}}",
    "reason_assist_note": "Help code {{code}}: {{note}}",
    "form_note": "Next you'll confirm it's you with a passkey, then the remote tool opens on this computer.",
    "start_btn": "Confirm with passkey and start",
    "passkey_canceled": "Passkey confirmation was canceled; nothing was started.",
    "auth_waiting": "Follow your browser's prompt to confirm with your passkey…",
    "tool_first": "First time using remote assistance on this computer?",
    "tool_first_body": "Their screen appears in the “remote tool” window. Download and install it first; if it's already installed, just start.",
    "tool_missing": "The remote tool didn't open?",
    "tool_missing_body": "It may not be installed on this computer. Install it and come back to this page — it opens again automatically (within 2 minutes). After that, cancel and start again.",
    "dl": {
      "windows": "Download remote tool (Windows)",
      "macos": "Download remote tool (macOS)",
      "linux": "Download remote tool (Linux)"
    },
    "dl_none": "No download location is set up for the remote tool here. Ask your system administrator.",
    "relaunch": "Open remote tool",
    "tool_installed": "It's installed",
    "tool_open": "The remote tool is open; you'll see their screen once they allow.",
    "tool_opening": "Opening the remote tool… If nothing happens,",
    "waiting": "Waiting for {{name}} to allow ({{time}})",
    "waiting_over": "No answer from {{name}} yet, checking…",
    "waiting_body": "An Allow window popped up on {{name}}'s computer; only they can click it. You can call and ask them to click Allow.",
    "cancel_session": "Cancel this session",
    "connected": "Connected to {{host}}",
    "connected_body": "Their screen is in the remote tool window. {{name}} sees a red frame and a floating bar the whole time and can end it or take back permissions at any moment.",
    "slow": "Slower connection",
    "upgrade_waiting": "Waiting for {{name}} to allow {{what}} ({{time}})",
    "upgrade_input_off": "Your mouse and keyboard are paused while you wait.",
    "extend_what": "{{n}} more minutes",
    "col_perms": "Permissions",
    "col_until": "Time",
    "until": "Ends automatically at {{time}} ({{n}} min left)",
    "col_recording": "Recording",
    "tip_uac": "When a system permission window shows on their screen you can't see it — ask them to click it.",
    "tip_cad": "Ctrl+Alt+Del can't be sent (system security screen).",
    "add_title": "Permissions to add",
    "add_note": "An Allow window pops up again on {{name}}'s computer; if they don't allow, current permissions stay. You'll confirm with your passkey first.",
    "add_send": "Confirm with passkey and send",
    "add_btn": "Add permissions…",
    "extend_btn": "Extend {{n}} min",
    "end_btn": "End session",
    "ended_title": "Remote assistance on {{host}} has ended",
    "ended_by": {
      "operator_end": "You ended this session.",
      "user_end": "{{name}} clicked End.",
      "time_limit": "Time ran out; it ended automatically."
    },
    "col_duration": "Duration",
    "col_files": "Files transferred",
    "no_files": "No files transferred",
    "note": "Add a note (goes into the history)",
    "note_ph": "e.g. Reset the print queue, back to normal",
    "external_ticket": "External ticket (optional)",
    "external_ticket_ph": "e.g. SR-20481",
    "note_audit": "The note and ticket go into this session's history; organization admins can see them.",
    "note_saved": "Saved to the history.",
    "note_save_close": "Save to history and close",
    "note_then_close": "Add a note and close",
    "note_shown": "Note: {{note}} · External ticket: {{ticket}}",
    "done": "Done",
    "done_no_note": "Close without a note",
    "close": "Close",
    "retry": "Try again",
    "go_passkey": "Register a passkey",
    "go_policy": "Open security policy",
    "go_seats": "Reassign licenses",
    "err_code": "Error code {{code}}",
    "dur_lt_min": "Under 1 minute",
    "dur_h_m": "{{h}} h {{m}} min",
    "out": {
      "denied": "{{name}} declined this session",
      "reported": "{{name}} reported they didn't ask for help",
      "timeout": "{{name}} didn't respond",
      "no_user": "Nobody is signed in on this computer — attended assistance needs someone at the screen to click Allow",
      "locked": "{{name}}'s screen is locked — ask them to unlock it first",
      "reported_recently": "Someone on this computer clicked “I didn't ask for help” in the last 24 hours",
      "region": "This computer is in mainland China; remote assistance isn't available",
      "allowance": "This computer's settings don't allow remote assistance",
      "org_policy": "The organization's security policy has remote assistance turned off",
      "paused": "Remote assistance is paused",
      "global_stop": "Kinio has paused all remote assistance",
      "unsupported_desktop": "This computer's desktop doesn't support remote assistance yet",
      "role": "You don't have remote assistance permission for this computer",
      "forbidden": "You don't have remote assistance permission for this computer",
      "busy": "This computer already has a remote session in progress",
      "offline": "This computer is offline",
      "unlicensed": "This computer is unlicensed and can't be assisted remotely",
      "taken": "Someone has already taken this request",
      "assist_expired": "This help request has expired",
      "need_passkey": "You need a passkey for remote assistance",
      "receipt": "Identity confirmation didn't pass",
      "too_many": "You have too many remote sessions at once",
      "no_answer": "This computer didn't answer",
      "connect_failed": "{{name}} allowed it, but the connection didn't come up",
      "connection_lost": "The connection dropped; the session has ended",
      "expired": "This attempt has expired",
      "revoked": "Your remote assistance permission was taken back; the session has ended",
      "kill_switch": "The organization stopped remote assistance; the session has ended",
      "error": "Didn't start",
      "unlock_timeout": "{{name}} didn't unlock the screen"
    },
    "out_next": {
      "denied": "You can add a note to the history. If needed, call them first and start again.",
      "reported": "{{org}}'s admins have been notified; you can't start a session on this computer for 24 hours.",
      "timeout": "Not clicking Allow within 60 seconds counts as declining. Call them to get ready, then try again.",
      "no_user": "Ask them to sign in and click “Request remote assistance” in the system tray; it shows up under Help requests.",
      "locked": "Once they unlock, click Try again.",
      "reported_recently": "For now only they can start it: they click “Request remote assistance” in the system tray, then you start from Help requests.",
      "region": "Remote assistance is not offered for computers in mainland China.",
      "allowance": "An organization owner or admin has to widen this computer's allowed actions.",
      "org_policy": "An organization owner or admin can turn it on in Organization settings › IT monitoring › Security policy.",
      "paused": "The user of this computer or the organization paused automatic actions and remote assistance; try again after it resumes.",
      "global_stop": "Monitoring, incidents and notifications continue; only Kinio can resume.",
      "unsupported_desktop": "On Linux only X11 desktops are supported for now.",
      "role": "Ask an organization admin for the “Remote assistance (attended)” permission.",
      "forbidden": "Ask an organization admin for the “Remote assistance (attended)” permission.",
      "busy": "Wait for that one to end. If it's yours, go to Remote assistance › History and click Resume.",
      "offline": "Try again once it's online.",
      "unlicensed": "Reassign a license under Hosts › Unlicensed, then start again.",
      "taken": "Only one person can help with a request.",
      "assist_expired": "Requests expire after 30 minutes; ask them to request again from the system tray.",
      "need_passkey": "Every remote session is confirmed with a passkey (verification codes don't count). Register one in My account › Security.",
      "receipt": "The confirmation may have timed out or this computer's clock is off. Try again.",
      "too_many": "One person can run at most 3 at once; end another one first.",
      "no_answer": "It may have just gone offline. Try again in a moment.",
      "connect_failed": "The remote tool didn't connect within 60 seconds. Make sure it's open, then try again.",
      "connection_lost": "Their computer was disconnected for over 30 seconds. You can try again.",
      "expired": "Identity confirmation wasn't finished within 5 minutes. Try again.",
      "revoked": "",
      "kill_switch": "",
      "error": "Please try again.",
      "unlock_timeout": "Once they unlock, click Try again — or ask them to click Request remote assistance in the system tray."
    },
    "state": {
      "requested": "Preparing",
      "awaiting_consent": "Waiting for them to allow",
      "active": "In progress",
      "upgrade_pending": "In progress (waiting to add permissions)"
    },
    "end": {
      "denied": "Declined",
      "reported": "Reported as not requested",
      "timeout": "No response",
      "operator_end": "Ended",
      "user_end": "Ended by them",
      "revoked": "Permission taken back",
      "time_limit": "Time ran out",
      "kill_switch": "Stopped by organization",
      "rejected": "Didn't start (computer couldn't accept then)",
      "expired": "Identity confirmation not finished",
      "connect_failed": "Didn't connect",
      "connection_lost": "Connection dropped",
      "unknown": "Ended"
    },
    "unreadable": "Can't read the host list",
    "no_hosts": "No computers in this scope yet",
    "no_hosts_body": "Once computers are enrolled you can help them from here.",
    "forbidden": "You don't have remote assistance permission",
    "forbidden_body": "Help requests need the “Remote assistance (attended)” permission; the History tab shows sessions you started. Ask an organization admin.",
    "assist_partial": "Help requests for {{n}} organizations couldn't be read",
    "assist_title": "{{who}} is asking for help",
    "assist_code": "Help code {{code}}",
    "assist_age": "Sent {{time}}",
    "assist_left": "Expires in {{n}} min",
    "assist_taken": "{{name}} took it",
    "assist_start": "Start helping",
    "assist_note": "On the phone, check the help code with them to be sure it's the same computer; they still have to click Allow.",
    "assist_none": "No help requests right now",
    "assist_none_body": "When someone clicks “Request remote assistance” in their computer's system tray it shows up here, and people with permission are notified.",
    "other_member": "Another member",
    "range_from": "From",
    "range_to": "To",
    "export_csv": "Export CSV",
    "csv": {
      "start": "Start",
      "end": "End",
      "minutes": "Duration (min)",
      "operator": "Operator",
      "org": "Organization",
      "home": "$t(translation:leaf.cur)",
      "host": "Host",
      "permissions": "Permissions",
      "result": "Result",
      "reason": "Reason",
      "note": "Note",
      "external_ticket": "External ticket"
    },
    "records_unreadable": "Can't read the remote assistance history",
    "col_start": "Start",
    "col_host": "Host",
    "col_operator": "Operator",
    "col_result": "Result",
    "col_note": "Note / external ticket",
    "resume": "Resume",
    "resume_host": "Resume remote assistance",
    "ticket_short": "Ticket {{ticket}}",
    "records_note": "Duration counts from when they clicked Allow to the end; remote assistance is never recorded.",
    "records_none": "No remote assistance in this period",
    "records_none_body": "Try another period.",
    "host_btn": "Remote assistance",
    "block": {
      "unlicensed": "Unlicensed computers can't be assisted remotely",
      "inactive": "This computer is disabled",
      "offline": "This computer is offline",
      "region": "In mainland China; remote assistance isn't available",
      "allowance": "This computer's settings don't allow remote assistance",
      "local_paused": "The user paused remote assistance on this computer",
      "phone": "Start remote assistance from a computer"
    },
    "wait_unlock": "{{name}}'s screen is locked",
    "wait_unlock_body": "The Allow window will pop up again on its own once they unlock — no need to start over. Waiting until {{time}} at the latest. You can call and ask them to unlock.",
    "sent_to_console": "This computer has {{n}} other signed-in session(s); the Allow window went to {{name}} at the screen (console session).",
    "records_access_partial": "For some $t(translation:leaf.cur_lc_pl) you only see sessions you started (you don't have remote assistance in those $t(translation:leaf.cur_lc_pl) and aren't an organization owner or admin).",
    "records_access_own": "Only sessions you started are shown: you don't have remote assistance in this scope and aren't an organization owner or admin."
  },
  "review": {
    "go": "See computers waiting",
    "title": "Waiting for you ({{n}})",
    "intro": "Computers whose host name is not on the expected list, or matches one already enrolled, wait here. Until you accept them they get no identity and use no token count or seat. They retry every 15 minutes.",
    "selected": "{{n}} selected",
    "select_hint": "Select several to handle them together",
    "select_all": "Select all waiting computers",
    "select_one": "Select {{host}}",
    "reject_btn": "Reject…",
    "accept_btn": "Accept…",
    "col_reason": "Why",
    "col_seen": "Seen",
    "col_actions": "Actions",
    "no_hostname": "(no host name reported)",
    "reason_not_listed": "Not on expected list",
    "reason_duplicate_name": "Same name as an enrolled computer",
    "first": "First {{time}}",
    "last": "Last {{time}}",
    "inactive": "This token can no longer be used, so these computers cannot be accepted. Create a new token to add them.",
    "none_pending": "No computers are waiting for you.",
    "done_title": "Handled ({{n}})",
    "state_pending": "Waiting",
    "state_accepted": "Accepted",
    "state_rejected": "Rejected",
    "state_expired": "Token ended before handling",
    "accept_title": "Accept {{n}} computers",
    "accept_body": "{{list}}: once accepted they get an identity, join this token’s $t(translation:leaf.cur_lc) and use {{n}} of the token count and seats (unlicensed if no seat is free) · enrollment completes within about 15 minutes. You will confirm your identity first.",
    "accept": "Accept",
    "reject_title": "Reject {{n}} computers",
    "reject_body": "{{list}}: they will be refused with this token from now on, even if renamed. Rebuild the token to add them later.",
    "reject": "Reject",
    "partial": "Handled {{ok}}; not handled: {{bad}}",
    "accepted_n": "Accepted {{n}}; enrollment completes within about 15 minutes.",
    "rejected_n": "Rejected {{n}}.",
    "err_done": "already handled or not on this token"
  },
  "tpl": {
    "intro": "Save thresholds, probes, automatic action rules, notifications and maintenance / business hours as a template and apply it to many $t(translation:leaf.cur_lc_pl) at once. A new template version is not pushed automatically; apply it again.",
    "show_archived": "Show archived",
    "new": "New template",
    "new_title": "New monitoring template",
    "empty_title": "No monitoring templates yet",
    "empty_body": "Create a template, then pick $t(translation:leaf.cur_lc_pl) under Apply, review the differences and apply.",
    "col_name": "Name",
    "col_items": "Contents",
    "col_version": "Version",
    "col_updated": "Last changed",
    "col_started": "Started",
    "col_state": "Status",
    "col_result": "Result",
    "col_home": "$t(translation:leaf.cur)",
    "archived": "Archived",
    "archived_note": "This template is archived: it can't be applied again; $t(translation:leaf.cur_lc_pl) that used it still show it as their source.",
    "new_hosts_note": "Computers that enroll later don't get the template's probes and rules automatically; apply the template again.",
    "unavailable": "Couldn't load monitoring templates",
    "applied_homes": "Applied to {{n}} $t(translation:leaf.cur_lc)(s)",
    "tabs": "Template tabs",
    "tab_content": "Contents",
    "tab_apply": "Apply",
    "tab_jobs": "History",
    "item_severity_overrides": "Thresholds and severity",
    "item_maintenance": "Maintenance windows",
    "item_business_hours": "Business hours",
    "item_notify": "Notifications",
    "item_probes": "Probes",
    "item_auto_rules": "Automatic action rules",
    "item_hint_severity_overrides": "When checked, the template manages every condition and number (unchanged ones use the defaults).",
    "item_hint_maintenance": "Weekly recurring maintenance windows; one-off maintenance isn't part of a template.",
    "item_hint_business_hours": "Outside business hours, offline cameras and workstations drop one severity level.",
    "item_hint_notify": "Only the on-call schedule; the customer contact belongs to the customer and is never changed.",
    "item_hint_probes": "Described by target type and matched to each $t(translation:leaf.cur_lc)'s existing hosts, network devices or collectors; no fixed IPs.",
    "item_hint_auto_rules": "In $t(translation:leaf.cur_lc_pl) of another organization, rules take effect only after the customer's owner / admin signs them with a passkey.",
    "item_off": "The template doesn't manage this ($t(translation:leaf.cur_lc_pl) keep their own setting).",
    "name": "Name",
    "description": "Description (optional)",
    "not_included": "Templates never include credentials, deployment tokens, allowance policies or the customer contact.",
    "pick_schedule": "Choose a schedule",
    "notify_hint": "Must be a schedule of this organization; after applying, incidents in customer $t(translation:leaf.cur_lc_pl) go to its on-call people.",
    "probe_name": "Name",
    "key": "Key",
    "probe_match": "Targets",
    "probe_kind": "Check",
    "match_servers": "Servers",
    "match_critical": "Critical hosts",
    "match_workstations": "Workstations",
    "match_all_hosts": "All hosts",
    "match_network_devices": "All network devices (with SNMP)",
    "match_collector_self": "The collector itself",
    "kind_ping": "Ping",
    "kind_tcp": "TCP port",
    "kind_http": "HTTP(S)",
    "kind_file": "File freshness",
    "port": "Port",
    "http_path": "Path",
    "file_path": "File path",
    "interval": "Check every",
    "seconds": "{{n}} s",
    "add_probe": "Add probe",
    "probe_note": "The key identifies the probe within the template; the same key across versions is the same probe.",
    "rule_service": "Service name",
    "rule_hosts": "Hosts",
    "rule_checks": "Consecutive failures",
    "add_rule": "Add rule",
    "rule_note": "Restarts a stopped service once; not created in $t(translation:leaf.cur_lc_pl) where it matches more than 3 hosts (a person handles those).",
    "err_name": "Enter a name",
    "err_empty": "Add at least one item",
    "err_maint_empty": "Add at least one maintenance window",
    "err_schedule": "Choose a schedule",
    "err_key": "Keys use lowercase letters, digits, _ or -",
    "err_key_dup": "Duplicate key",
    "err_port": "TCP needs a port",
    "err_http_path": "HTTP path must start with /",
    "err_file": "File freshness only checks the collector itself and needs a path",
    "err_service": "Enter a service name",
    "save": "Save",
    "create": "Create template",
    "save_note": "Changing the contents creates a new version; $t(translation:leaf.cur_lc_pl) already applied aren't updated automatically.",
    "saved": "Saved.",
    "saved_version": "Saved as v{{v}}. Use Apply to roll it out to $t(translation:leaf.cur_lc_pl).",
    "conflict": "Someone just changed this template. Reload and try again.",
    "archive": "Archive",
    "archive_confirm": "Archived templates can't be applied; $t(translation:leaf.cur_lc_pl) that used it aren't affected. Archive it?",
    "pick_intro": "Choose the $t(translation:leaf.cur_lc_pl) to apply v{{v}} to (you need the configure permission in each $t(translation:leaf.cur_lc), delegation counts). You'll review the differences next.",
    "pick_filter": "Search $t(translation:leaf.cur_lc_pl)",
    "pick_all": "Select all ({{n}})",
    "pick_none": "Clear",
    "picked": "{{n}} $t(translation:leaf.cur_lc)(s) selected",
    "preview_note": "Previewing changes nothing; $t(translation:leaf.cur_lc_pl) are processed 200 at a time.",
    "preview": "Preview differences ({{n}})",
    "diff_summary": "{{homes}} $t(translation:leaf.cur_lc)(s), {{changes}} change(s); {{orgs}} customer organization(s) involved, each gets one notification after applying.",
    "show_same": "Show unchanged items",
    "pending_rules": "{{n}} automatic action rule(s) will wait for {{org}} to sign with a passkey and won't run until then.",
    "n_homes": "{{n}} $t(translation:leaf.cur_lc)(s)",
    "n_changes": "{{n}} change(s)",
    "customer_field": "Customer setting ({{v}}); the template won't change it",
    "skip_no_target": "Nothing in this $t(translation:leaf.cur_lc) matches; this one isn't created",
    "skip_too_many_targets": "Matches more than 3 hosts; not created automatically (a person handles it)",
    "ov_by": "Changed by {{org}} ({{name}} {{date}})",
    "fate_keep": "Kept by default",
    "fate_overwrite": "Will be overwritten",
    "overwrite_anyway": "Overwrite anyway",
    "pending_rule_row": "Waits for the customer's signature after applying",
    "skipped_title": "{{n}} $t(translation:leaf.cur_lc)(s) skipped",
    "reason_no_permission": "You can't configure this $t(translation:leaf.cur_lc)",
    "reason_not_enabled": "IT monitoring isn't enabled in this $t(translation:leaf.cur_lc)",
    "reason_no_target": "None of the template's probes or rules match anything in this $t(translation:leaf.cur_lc)",
    "reason_cancelled": "Cancelled, not applied",
    "reason_error": "Couldn't apply for now (tried 3 times)",
    "reason_feature_disabled": "Automatic actions aren't enabled in this environment",
    "reason_rule": "Couldn't write an automatic action rule ({{detail}})",
    "back_pick": "Change $t(translation:leaf.cur_lc_pl)",
    "apply_note": "Applying changes settings in customer $t(translation:leaf.cur_lc_pl); you'll be asked to verify your identity.",
    "apply": "Apply to {{n}} $t(translation:leaf.cur_lc)(s)",
    "apply_confirm": "Apply to {{n}} $t(translation:leaf.cur_lc)(s)? {{orgs}} customer organization(s) will be notified; items the customer changed follow the checkboxes above.",
    "apply_ok": "Apply",
    "preview_expired": "The preview expired (10 minutes). Preview again.",
    "jobs_empty": "Not applied yet",
    "job_queued": "Queued",
    "job_running": "Applying",
    "job_done": "Done",
    "job_cancelled": "Cancelled",
    "job_counts": "Applied {{applied}}, skipped {{skipped}}, failed {{failed}} (of {{total}})",
    "job_progress": "{{done}} / {{total}}",
    "cancelling": "Cancelling: stops after the current home",
    "notified": "{{n}} customer organization(s) notified",
    "cancel": "Cancel",
    "retry": "Retry {{n}} failed $t(translation:leaf.cur_lc)(s)",
    "result_pending": "Waiting",
    "result_applied": "Applied",
    "result_skipped": "Skipped",
    "result_failed": "Failed",
    "home_result": "{{changed}} changed, {{kept}} kept",
    "home_pending": "{{n}} rule(s) await the customer's signature",
    "changed_since_preview": "Changed by the customer after the preview; recalculated at apply time",
    "num_disk_pct": "Disk almost full",
    "num_tls_days": "TLS expiry days",
    "num_workstation_offline_days": "Workstation offline days",
    "key_schedule": "Schedule",
    "key_customer_contact": "Customer contact",
    "v_none": "None",
    "v_owner_default": "$t(translation:leaf.cur) owner (default)",
    "v_days": "{{n}} days",
    "v_collector_local": "Collector itself",
    "v_probes": "{{n}} probe(s) ({{targets}})",
    "v_rule": "Restart {{service}} when stopped · {{checks}} in a row · {{n}} host(s)",
    "home_using": "Uses {{org}}'s monitoring template {{name}} v{{v}}",
    "home_overrides": "{{n}} item(s) changed here",
    "home_archived": "{{name}} is archived",
    "home_newer": "{{name}} has a new version v{{v}}",
    "show_diff": "See differences",
    "hide_diff": "Hide",
    "apply_to_others": "Apply to other $t(translation:leaf.cur_lc_pl)…",
    "from_home_name": "Settings of {{home}}",
    "from_home_title": "Create a template from the current settings of “{{home}}”",
    "from_home_note": "Thresholds and severity, maintenance windows, business hours and the on-call schedule of “{{home}}” are filled in. Probes and auto actions target this $t(translation:leaf.cur_lc)'s own hosts; add them below by target category if needed. After saving, pick the $t(translation:leaf.cur_lc_pl) to apply to.",
    "from_home_skip_notify": "The on-call schedule used for notifications belongs to another organization and was not filled in.",
    "from_home_failed": "Couldn't read the current settings of this $t(translation:leaf.cur_lc); choose the items to manage yourself.",
    "pick_from_home": "The source home “{{home}}” is not listed.",
    "item_power": "Energy alerts (PoE thresholds)",
    "power_warn": "Warning",
    "power_high": "High",
    "power_hint": "Share of the Station / switch rated PoE power that is allocated or used (50–100%). Applied to each $t(translation:leaf.cur_lc)’s energy settings, marked “managed by template” there.",
    "power_err": "Thresholds must be 50–100 and Warning can’t exceed High",
    "val_power": "PoE warning {{warn}}% · high {{high}}%",
    "item_hint_power": "Share of the Station / switch rated PoE power that is allocated or used (50–100%). Applied to each $t(translation:leaf.cur_lc)’s energy settings, marked “managed by template” there."
  },
  "install": {
    "title": "Install parameters",
    "tab_windows": "Windows",
    "tab_gpo": "GPO startup script",
    "tab_intune": "Intune",
    "tab_linux": "Linux",
    "tab_rmm": "RMM",
    "note_windows": "Run as administrator; the computer enrolls automatically after the silent install.",
    "note_gpo": "Computer Configuration › Windows Settings › Scripts › Startup. Keep the script and installer in a share only domain computer accounts can read: if domain users can read it, every domain user has the token. Intune is recommended.",
    "note_intune": "Install command of a Win32 app; set install behavior to System. Only Intune admins can see the token.",
    "note_linux": "Run after installing the package; the token is read from standard input and stays out of the command line.",
    "note_rmm": "Install variables for your RMM tool (put them in a secret field only admins can see).",
    "gpo_download": "Download GPO startup script"
  },
  "built": {
    "new_title": "Set up an organization for a customer",
    "new_body": "You are the temporary owner of the organization you set up: prepare $t(translation:leaf.cur_lc_pl), on-call schedules, templates and tokens, then invite the customer to take over. It does not count toward your own 5 organizations. \"{{org}}\" can have up to 20 organizations that have not been handed over.",
    "name": "Customer's organization name",
    "create": "Set up for customer",
    "switched": "Switched to \"{{name}}\"",
    "limit": "Up to {{n}} organizations can be waiting for handover. Have a customer complete the handover first.",
    "unavailable": "Could not load the customers you set up",
    "none": "No customers waiting for handover",
    "none_body": "Organizations that were handed over are not listed here; after the handover, delegations define the relationship.",
    "count": "{{n}} / {{max}} waiting for handover",
    "col_name": "Organization",
    "col_builder": "Set up by",
    "col_customer": "Customer",
    "col_created": "Created",
    "customer_owner": "{{name}} (ownership transferred)",
    "customer_joined": "{{name}} (joined)",
    "customer_invited": "Invited {{email}}",
    "customer_none": "Not invited yet"
  },
  "handover": {
    "title": "Handover",
    "partner_fallback": "the installer",
    "builder_fallback": "the builder",
    "customer_fallback": "the customer",
    "not_built": "Nothing to hand over",
    "not_built_body": "This organization was not set up by an installer, or the handover is complete.",
    "unavailable": "Could not load the handover progress",
    "intro_customer": "\"{{partner}}\" set up \"{{org}}\" for you. Complete the handover in this order",
    "intro_builder": "You are setting up \"{{org}}\" for a customer. Hand it over in this order",
    "remaining": "{{n}} steps left",
    "dpa_bar": "The customer has not accepted the data processing agreement yet, so installed computers do not start reporting (they retry every 15 minutes; no reinstall needed).",
    "dpa_builder": "The customer must accept the data processing agreement. You can do the other steps; computers do not start reporting until the customer accepts.",
    "empty_keyset": "No one can loosen the computers' settings in this organization right now: confirm on any computer as a local administrator, or rerun the install with a new token.",
    "invite_title": "Invite the customer",
    "invite_body": "Once the customer joins with an account of the same brand, they can take over on this page. People without an account get a sign-up link.",
    "invite_email": "Customer's email",
    "invite_btn": "Invite customer",
    "invite_again": "Send to this address instead",
    "invite_pending": "Invited {{email}} (valid until {{until}})",
    "invited": "Invited {{email}}",
    "step_owner": "Transfer ownership to \"{{customer}}\"",
    "step_dpa": "Accept the data processing agreement",
    "step_delegation": "Delegate to \"{{partner}}\"",
    "step_template": "Monitoring templates",
    "step_customer_key": "Add {{customer}}'s key to the computers' admin list",
    "step_builder_key": "Remove {{builder}}'s key",
    "step_builder_left": "\"{{builder}}\" completes the handover and leaves",
    "state_done": "Done",
    "state_skipped": "Skipped",
    "state_todo": "Current step",
    "state_waiting": "Waiting for earlier steps",
    "why_owner": "\"{{builder}}\" becomes an organization admin until leaving.",
    "why_dpa": "Only the customer can accept; computers start reporting after that.",
    "why_delegation": "Suggested scope: view + configure and one-off actions, 12 months. If you skip it, \"{{partner}}\" cannot see or help after the handover.",
    "why_template": "Templates applied during setup: keep them, or revert to defaults (removes probes added by templates and rules that never ran).",
    "why_customer_key": "Once added, you can loosen settings on the computers. \"{{builder}}\" signs it with their key.",
    "why_builder_key": "Tokens created by \"{{builder}}\" stop working; \"{{partner}}\" rebuilds them through the delegation.",
    "why_builder_left": "After leaving, the setup relationship ends; only delegations remain.",
    "wait_builder": "Waiting for \"{{builder}}\"",
    "wait_customer": "Waiting for \"{{customer}}\"",
    "owner_btn": "Transfer ownership to \"{{customer}}\"",
    "owner_need_customer": "Invite the customer first",
    "owner_confirm_title": "Transfer ownership of \"{{org}}\" to \"{{customer}}\"",
    "owner_confirm_body": "You become an organization admin. Next, \"{{customer}}\" accepts the data processing agreement.",
    "dpa_btn": "Review and accept",
    "deleg_btn": "Delegate to \"{{partner}}\"…",
    "skip_btn": "Skip",
    "skip_title": "Skip the delegation",
    "skip_body": "If you skip it, \"{{partner}}\" cannot see or help after the handover. You can delegate any time under External organizations.",
    "tpl_keep": "Keep",
    "tpl_row": "{{home}}: {{name}} v{{v}}",
    "revert_btn": "Revert to defaults",
    "revert_title": "Revert to defaults",
    "revert_body": "Template items are removed from {{n}} $t(translation:leaf.cur_lc_pl): probes added by templates and rules that never ran are deleted; thresholds and notifications keep their current values.",
    "sign_btn": "Sign \"add {{customer}}'s public key\"",
    "no_candidate": "\"{{customer}}\" has not registered a signing passkey yet. Ask them to register one.",
    "request_body": "Register your signing passkey under Admin passkeys first, then ask \"{{builder}}\" to add it to the computers' admin list.",
    "request_btn": "Ask \"{{builder}}\" to add your key",
    "request_sent_at": "Notified \"{{builder}}\" at {{time}}",
    "register_key": "Register my signing passkey",
    "sign_sent": "Notified \"{{builder}}\"",
    "sign_wait": "Already notified; you can notify again after {{time}}",
    "remove_btn": "Remove my key",
    "remove_confirm_title": "Remove your key",
    "remove_confirm_body": "The {{n}} tokens you created stop working; \"{{partner}}\" rebuilds them through the delegation, without going through you. Enrolled computers are not affected.",
    "tokens_title": "Tokens created by \"{{builder}}\" ({{n}}) will stop working",
    "token_row": "{{name}} · until {{until}} · {{n}} not enrolled",
    "tokens_note": "\"{{partner}}\" rebuilds them through the delegation, without going through you; you never need to pass a token to anyone.",
    "tokens_ack": "Got it",
    "revoke_btn": "Revoke now",
    "revoke_title": "Revoke {{n}} tokens",
    "revoke_body": "Computers that have not enrolled will fail until \"{{partner}}\" rebuilds the token and updates the install settings.",
    "leave_btn": "Complete handover and leave",
    "leave_title": "Leave \"{{org}}\"",
    "leave_body": "All your access to \"{{org}}\" is removed and your remaining tokens are revoked. After that, \"{{partner}}\" can only act through a delegation.",
    "incomplete_owner_not_transferred": "Ownership has not been transferred to the customer yet.",
    "incomplete_customer_key_missing": "{{customer}}'s key is not on the computers' admin list yet.",
    "incomplete_builder_key_present": "Your key is still on the computers' admin list. Remove it first.",
    "conflict_handover_invite_exists": "A customer has already been invited. To change, withdraw the invitation or remove that member first.",
    "conflict_not_built_org": "This organization is not waiting for handover.",
    "conflict_already_added": "Your key is already on the list.",
    "conflict_no_candidate": "You have not registered a signing passkey yet. Register one under Admin passkeys.",
    "not_handover_customer": "An organization set up for a customer can only be transferred to that customer.",
    "banner_customer": "\"{{partner}}\" set up this organization for you",
    "banner_builder": "You are setting up \"{{org}}\" for a customer",
    "banner_steps": " — {{n}} steps left",
    "banner_continue": "Continue"
  },
  "market": {
    "title": "Not currently available in your region",
    "agent_body": "Based on the region you are connecting from, {{agent}} is not available to download or install.",
    "tool_body": "Based on the region you are connecting from, the remote tool is not available to download."
  },
  "power": {
    "phase_outage": "Outage (on battery)",
    "phase_waiting": "Power is back; {{n}} still not back",
    "phase_restored": "Recovered",
    "runtime_big": "About {{n}} min left",
    "runtime_unk": "Runtime unavailable",
    "runout": "Runs out around {{time}}",
    "battery_pct": "Battery {{pct}}%",
    "load_pct": "Load {{pct}}%",
    "chart_title": "Battery level since {{time}}",
    "chart_none": "Battery level for the last 30 minutes is unavailable",
    "show_numbers": "Show numbers",
    "col_time": "Time",
    "downstream_line": "Behind this UPS: {{n}} ({{off}} offline)",
    "downstream_line_ok": "Behind this UPS: {{n}}",
    "no_downstream": "Unknown which equipment is behind this UPS",
    "no_downstream_rec": "Recording: unknown whether recorders are behind a UPS",
    "register": "Register equipment",
    "offline_title": "Not back yet",
    "skip": "Don’t wait for this",
    "skip_aria": "Don’t wait for this: {{name}}",
    "skip_done": "No longer waiting for {{name}}",
    "escalate_note": "If anything is still down 30 minutes after power returns, it escalates per the on-call rota",
    "events_title": "Battery transfers",
    "event_line": "{{from}}–{{to}} ({{min}} min)",
    "event_ongoing": "Since {{from}}, still on battery",
    "escalated": "Escalated",
    "live_15": "UPS has under 15 minutes left",
    "live_5": "UPS has under 5 minutes left",
    "impact_title": "Outage impact",
    "row_line": "UPS about {{n}} min left (load {{load}}%)",
    "row_line_noload": "UPS about {{n}} min left",
    "row_line_unk": "UPS runtime unavailable",
    "col_name": "Name",
    "col_state": "Status",
    "col_battery": "Battery",
    "col_runtime": "Runtime",
    "col_load": "Load",
    "col_downstream": "Downstream",
    "st_normal": "Mains",
    "st_battery": "On battery {{n}} min",
    "st_bypass": "Bypass",
    "st_none": "Output off",
    "st_other": "Other",
    "st_selftest": "Self-test",
    "st_unreadable": "Unavailable (last {{time}})",
    "val_unk": "Unavailable",
    "minutes": "{{n}} min",
    "downstream_n": "{{n}}",
    "downstream_none": "Not registered",
    "todo_hint": "No equipment registered behind this UPS: in an outage each device will open its own incident",
    "empty": "No UPS in this scope yet. UPS units the collector reads over SNMP (UPS-MIB or APC) appear here automatically.",
    "load_err": "Couldn’t load UPS data",
    "detail_back": "Back to UPS list",
    "metrics": "Readings",
    "input_v": "Input voltage",
    "output_w": "Output power",
    "temp": "Battery temperature",
    "test": "Self-test",
    "test_pass": "Passed",
    "test_warning": "Warning",
    "test_error": "Failed",
    "test_aborted": "Aborted",
    "test_in_progress": "In progress",
    "test_none": "None",
    "alarms": "Reported by the UPS",
    "alarms_none": "None",
    "downstream_title": "Behind this UPS",
    "outage_open": "Outage incident open",
    "see_incident": "View incident",
    "dlg_title": "Register equipment behind “{{name}}”",
    "dlg_hint": "During an outage, these going offline are merged into one outage incident instead of separate ones. Register recorders (NVR / Station) so the incident can show recording impact.",
    "dlg_kinio": "Kinio devices",
    "dlg_hosts": "Computers",
    "dlg_net": "Network devices",
    "dlg_search": "Find equipment",
    "dlg_all_group": "Select all in “{{group}}”",
    "dlg_save": "Save ({{n}})",
    "dlg_saved": "{{n}} registered",
    "dlg_max": "Up to 200",
    "dlg_cancel": "Cancel",
    "dlg_none": "Nothing to register in this $t(translation:leaf.cur_lc)",
    "no_configure": "You don’t have monitoring settings permission for this $t(translation:leaf.cur_lc)",
    "alarm": {
      "battery_bad": "Battery needs replacing",
      "on_battery": "On battery",
      "low_battery": "Low battery",
      "depleted_battery": "Battery depleted",
      "temp_bad": "Temperature out of range",
      "input_bad": "Input power problem",
      "output_bad": "Output problem",
      "output_overload": "Output overload",
      "on_bypass": "On bypass",
      "bypass_bad": "Bypass problem",
      "output_off_as_requested": "Output off as requested",
      "ups_off_as_requested": "UPS off as requested",
      "charger_failed": "Charger failed",
      "ups_output_off": "Output off",
      "ups_system_off": "UPS system off",
      "fan_failure": "Fan failure",
      "fuse_failure": "Fuse failure",
      "general_fault": "General fault",
      "diagnostic_test_failed": "Self-test failed",
      "communications_lost": "Communications lost",
      "awaiting_power": "Awaiting power",
      "shutdown_pending": "Shutdown pending",
      "shutdown_imminent": "Shutdown imminent",
      "test_in_progress": "Self-test in progress"
    }
  }
}
